export const BIKES_BASE_PATH = `/vehicles/bikes-escooters/abandoned`;
export const RoutesList = {
  TEST_LANDING_PAGE: '/',
  CALLBACKS: BIKES_BASE_PATH + '/callbacks/*',
  BIKES_HOME: BIKES_BASE_PATH,
  UPLOAD_PHOTO: BIKES_BASE_PATH + '/upload-photo',
  UPLOAD_QR_CODE_PHOTO: BIKES_BASE_PATH + '/upload-qr-code-photo',
  REPORTER_LOCATION: BIKES_BASE_PATH + '/reporter-location',
  BIKES_LOCATION: BIKES_BASE_PATH + '/bikes-location',
  EMAIL_CONFIRMATION_REPORT: BIKES_BASE_PATH + '/email-confirmation-report',
  YOUR_DETAILS: BIKES_BASE_PATH + '/your-details',
  CONFIRMATION: '/confirmation',
  WHAT_HIRE_COMPANY: BIKES_BASE_PATH + '/what-hire-company',
  WHAT_IS_ISSUE: BIKES_BASE_PATH + '/what-is-issue',
  TELL_US_MORE: BIKES_BASE_PATH + '/tell-us-more',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
};

export const steps = [
  {
    label: 'Upload photo',
    urlPaths: [RoutesList.UPLOAD_PHOTO, RoutesList.UPLOAD_QR_CODE_PHOTO],
  },
  {
    label: 'Issue details',
    urlPaths: [
      RoutesList.REPORTER_LOCATION,
      RoutesList.BIKES_LOCATION,
      RoutesList.WHAT_HIRE_COMPANY,
      RoutesList.TELL_US_MORE,
      RoutesList.WHAT_IS_ISSUE,
    ],
  },
  {
    label: 'Your details',
    urlPaths: [RoutesList.EMAIL_CONFIRMATION_REPORT, RoutesList.YOUR_DETAILS],
  },
];
